export const QUESTION_MATRIX_BIPOLAR_STYLES = {
  HORIZONTAL: 'HORIZONTAL',
  VERTICAL: 'VERTICAL',
  SLIDER: 'SLIDER',
};
